export const formatDate = (date) => {
  const formatter = new Intl.DateTimeFormat('el-GR');
  return formatter.format(date); // check failure cases
};

export const dateFormatter = (date) => {
  if (date) {
    return date.toISOString().split('T')[0];
  }
  return date;
};
